import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Utility from "../../Utility";

class RequestDetailTable extends React.Component {
    render(){
        if(this.props.detail === null){
            return null;
        }

        return (
            <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">項目</TableCell>
                            <TableCell align="left">値</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">ID</TableCell>
                            <TableCell align="left">{this.props.detail.transactionId}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">申請状態</TableCell>
                            <TableCell align="left">{Utility.getProgressStatusNameFromValue(this.props.detail.progressStatus)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">配車期間</TableCell>
                            <TableCell align="left">{
                                Utility.formatDate(Utility.toDate(this.props.detail.expectedUseStartDate), 'yyyy/MM/dd')
                                + '～'
                                + Utility.formatDate(Utility.toDate(this.props.detail.expectedReturnDate), 'yyyy/MM/dd')
                            }</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">協力会社名</TableCell>
                            <TableCell align="left">{this.props.detail.businessPartnerName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">ポンプ仕様</TableCell>
                            <TableCell align="left">{this.props.detail.pompSpecName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">台数</TableCell>
                            <TableCell align="left">{this.props.detail.dispatchNum}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">配車先</TableCell>
                            <TableCell align="left">{this.props.detail.dispatchDestination}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">主要洗浄冶具</TableCell>
                            <TableCell align="left">{this.props.detail.mainCleaningJig}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">消耗品関係</TableCell>
                            <TableCell align="left">{this.props.detail.expendables}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">備考</TableCell>
                            <TableCell align="left">{this.props.detail.note}</TableCell>
                        </TableRow>
                        {this.props.detail.progressStatus === 2 &&
                        <TableRow>
                            <TableCell component="th" scope="row">却下理由</TableCell>
                            <TableCell align="left">{this.props.detail.cancelReason}</TableCell>
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default RequestDetailTable;